import { Events } from './Events.js';
import { Dispatcher } from './Dispatcher.js';

const Actions = {
  toggleProfileBox() {
    Dispatcher.emit(Events.TOGGLE_PROFILE_BOX);
  },
  closeProfileBox() {
    Dispatcher.emit(Events.CLOSE_PROFILE_BOX);
  },
  showProfileBox() {
    Dispatcher.emit(Events.SHOW_PROFILE_BOX);
  },
  logout() {
    Dispatcher.emit(Events.LOGOUT);
  },
  showError(text, type, title) {
    let typee = type != undefined ? type : 'warning';
    let titlee = title != undefined ? title : 'Ops.';
    Dispatcher.emit(Events.SHOW_ERROR, text, typee, titlee);
  },
  showSuccess(data) {
    Dispatcher.emit(Events.SHOW_SUCCESS, data);
  },
  showModalTreinamentos() {
    Dispatcher.emit(Events.SHOW_MODAL_TREINAMENTOS);
  },
  hideModalTreinamentos() {
    Dispatcher.emit(Events.HIDE_MODAL_TREINAMENTOS);
  },
  showModal(sendToApi = true) {
    Dispatcher.emit(Events.SHOW_MODAL, sendToApi);
  },
  hideModal() {
    Dispatcher.emit(Events.HIDE_MODAL);
  },
  showHeader() {
    Dispatcher.emit(Events.SHOW_HEADER);
  },
  hideHeader() {
    Dispatcher.emit(Events.HIDE_HEADER);
  },
  showFooter() {
    Dispatcher.emit(Events.SHOW_FOOTER);
  },

  headerIntern() {
    Dispatcher.emit(Events.HEADER_INTERN);
  },
  headerHome() {
    Dispatcher.emit(Events.HEADER_HOME);
  },


  hideFooter() {
    Dispatcher.emit(Events.HIDE_FOOTER);
  },
  showMenu() {
    Dispatcher.emit(Events.SHOW_MENU);
  },
  hideMenu() {
    Dispatcher.emit(Events.HIDE_MENU);
  },
  toggleMenu() {
    Dispatcher.emit(Events.TOGGLE_MENU);
  },


  menuIntern() {
    Dispatcher.emit(Events.MENU_INTERN);
  },
  menuHome() {
    Dispatcher.emit(Events.MENU_HOME);
  },
  logoHome() {
    Dispatcher.emit(Events.LOGO_HOME);
  },
  logoIntern() {
    Dispatcher.emit(Events.LOGO_INTERN);
  },
  successForm() {
    Dispatcher.emit(Events.SUCCESS_FORM);
  },
  globalTransition() {
    Dispatcher.emit(Events.GLOBAL_TRANSITION);
  },
  cepChange(data) {
    Dispatcher.emit(Events.CEP_CHANGE, data);
  },
  checkRegulamentoPreCadastro() {
    Dispatcher.emit(Events.CHECK_REGULAMENTO_PRECADASTRO);
  },
};

export { Actions };
